import React, { Component } from 'react'
import { Row, Collapse, Tooltip, Spin, Button } from 'antd';
import { Link, useHistory, withRouter } from 'react-router-dom';
import ComplexMenu from './complex_menu';
import { KeyboardArrowRightOutlined } from '@material-ui/icons';
import KeyboardShortcutWrapper from '../util/keyshortcuts/index';


const { Panel } = Collapse;
class SideMenu extends Component {
    render() {
        let menuItems = this.props.item || [];
        let menyKey = this.props.menuKey || "";

        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                color: 'white',
                position: 'relative'
            }}>
                {
                    menuItems.map((item, index) => {
                        return getMenuItem({
                            branchLevel: 0,
                            type: item.type,
                            menuKey: menyKey,
                            index: index,
                            history: this.props.history,
                            ...item
                        })
                    })
                }

            </div>
        )
    }
}

export default SideMenu=withRouter(SideMenu)


export const getMenuItem = ({ type, menuKey, ...props }) => {


    let isActive = props.isActive;

    let menuKeys = menuKey.split('/');
    // console.log("keys",menuKey,menuKeys)
    if (props.key_position != null) {
        let activeKey = menuKeys[props.key_position || 2] || "";
        // console.log("compairing",activeKey,props.key)
        if (activeKey == props.key) {
            isActive = true;
        }
    }

    let branchLevel = props.branchLevel || 0;
    let url = props.url;
    if (typeof props.urlMaker === 'function' && props.url == null) {
        url = props.urlMaker(props.param)
    }


    if (props.hasShortcut == true) {
        let history = props.history || {};

        console.log("has shortcut",props,history);
        return <KeyboardShortcutWrapper
            key={`${url}`}
            trigger={props.trigger}
            label={props.triggerLabel}
            onDown={() => {
                try {
                    history.push(`/${url}`)
                } catch (e) {
                    console.log("erorr history push", e)
                }
            }}
        >
            {getMenuItem({ type, menuKey, ...props ,hasShortcut:false})}
        </KeyboardShortcutWrapper>
    } else {

        switch (type) {
            case 'content':
                if (typeof props.render === 'function') {
                    return props.render({ type, menuKey, ...props });
                } else return <div>No render function</div>
            case 'loading':
                return <center key="loading"><Spin className='white-spin' /></center>
            case 'error':
                return <center key='retry'><Button type='link'
                    onClick={() => {
                        typeof props.onReload === 'function' && props.onReload();
                    }}
                    style={{
                        color: 'white'
                    }}>Retry</Button></center>
            case 'main':
                // console.log(menuKey,props)
                return <Link to={`/${url}`}
                    key={props.key || url}
                    style={{
                        ...props.mainStyle,
                        // borderTop:props.index!=0?'1px solid #fff':null
                        borderBottom: '1px solid #ffffff19'

                    }}
                ><Row type='flex' justify='start' style={{
                    color: 'white',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    paddingTop: 10,
                    paddingBottom: 10,
                    width: '100%',
                    // marginTop: 4,
                    // marginBottom: 4,
                    backgroundColor: menuKey.includes(url) ? '#273972' : 'transparent',
                    // borderRadius: 10,
                    // opacity: menuKey.includes(url) ? 1 : 0.8,
                    ...props.topStyle,

                }}
                    className='menu-item'
                >
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            flex: 1,
                            cursor: 'pointer',
                            justifyContent: 'space-between',
                            paddingRight: 8
                        }}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center'
                            }}>
                                {props.icon}
                                <Tooltip title={props.title} mouseEnterDelay={0.7}>
                                    <span style={{
                                        margin: 0,
                                        marginLeft: 14,
                                        fontSize: 16,
                                        width: 170,
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        fontWeight: 'bold'
                                    }}>{props.title}</span>
                                </Tooltip>
                            </div>
                            {props.iconRight}
                        </div>

                    </Row>
                </Link>

            case 'expandable':
                return <ExpandableMenu
                    menuKey={menuKey}
                    key={props.index}
                    title={props.title}
                    iconName={props.iconName}
                    icon={props.icon}
                    {...props}
                />
            case 'secondary':
                // console.log("menukey comp",menuKey,url);
                return <Link to={`/${url}`} key={props.index || url}><Row
                    type='flex' justify='start'
                    className='menu-item'
                    style={{
                        color: 'white',

                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        paddingTop: 10,
                        paddingBottom: 10,

                        cursor: 'pointer',
                        fontWeight: 'normal',
                        // marginTop: 2,
                        // marginBottom: 2,
                        backgroundColor: (menuKey.includes(url) && isActive) ? '#273972' : 'transparent',
                        // borderRadius: 10,
                        opacity: (menuKey.includes(url) && isActive) ? 1 : 0.8
                    }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flex: 1,
                        cursor: 'pointer'
                    }}>
                        {props.icon}
                        <Tooltip title={props.title} mouseEnterDelay={0.7}>
                            <span style={{
                                margin: 0,
                                fontSize: 12,
                                marginLeft: 16,
                                width: 180,
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                fontWeight: (menuKey.includes(url) && isActive) ? 'bold' : 'normal'
                            }}>{props.title}</span>
                        </Tooltip>
                    </div>

                    <div>

                    </div>

                </Row>
                </Link>;

            case 'complex':
                return <ComplexMenu
                    menuKey={menuKey}
                    key={props.index} {...props} />
            default:
                return <Row>

                </Row>
        }
    }
}

class ExpandableMenu extends React.Component {
    state = {
        expanded: (this.props.defaultExpanded || (this.props.menuKey.includes(this.props.active_url))) || false
    }
    render() {
        let expandTree = this.props.expandTree || 'primary';
        let childItem = this.props.childItem || [];
        let branchLevel = this.props.branchLevel || 0;
        let menuKey = this.props.menuKey;

        // console.log(this.props)

        return <div>
            {this.props.title_url ?
                <Link to={this.props.title_url} key={this.props.title_url} style={{
                    // borderBottom:'1px solid #ffffff19'

                }}>
                    <Row type='flex' justify='space-between' style={{
                        color: 'white',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        paddingTop: 10,
                        paddingBottom: 10,
                        width: '100%',
                        cursor: 'pointer',
                        // borderRadius: 10,
                        backgroundColor: menuKey.includes(this.props.title_url) ? '#273972' : 'transparent',
                        // opacity: menuKey.includes(this.props.title_url) ? 1 : 0.8
                        borderBottom: '1px solid #ffffff19'

                    }}
                        onClick={() => {
                            this.setState({
                                expanded: !this.state.expanded
                            })
                        }}
                    >
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            flex: 1,


                        }}>
                            {this.props.icon}
                            <Tooltip title={this.props.title}>
                                <span style={{
                                    margin: 0,
                                    marginLeft: 16,
                                    fontWeight: expandTree === 'primary' ? 'bold' : 'normal',
                                    fontSize: 16 - (branchLevel * 4),
                                    width: 160,
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                }}>{this.props.title}</span>
                            </Tooltip>
                        </div>
                        <div style={{
                             display:'flex',
                             alignItems:'center'
                        }}>
                            <KeyboardArrowRightOutlined onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                this.setState({
                                    expanded: !this.state.expanded
                                })
                            }} style={{
                                transform: `rotate(${this.state.expanded ? '90' : '0'}deg)`,
                                transition: 'transform 0.2s ',
                                marginRight: 6
                            }} type='right'
                            />
                        </div>

                    </Row>
                </Link>
                : <Row type='flex' justify='space-between' style={{
                    color: 'white',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    paddingTop: 10,
                    paddingBottom: 10,
                    width: '100%',
                    cursor: 'pointer',
                    borderBottom: '1px solid #ffffff19'

                }}
                    onClick={() => {
                        this.setState({
                            expanded: !this.state.expanded
                        })
                    }}
                // className='menu-item'
                >
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        flex: 1,


                    }}>
                        {this.props.icon}
                        <Tooltip title={this.props.title} mouseEnterDelay={0.5}>
                            <span style={{
                                margin: 0,
                                marginLeft: 16,
                                fontWeight: expandTree === 'primary' ? 'bold' : 'normal',
                                fontSize: 16 - (branchLevel * 4),
                                width: 150,
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                            }}>{this.props.title}</span>
                        </Tooltip>
                    </div>
                    <div style={{
                       
                    }}>
                        <KeyboardArrowRightOutlined style={{
                            transform: `rotate(${this.state.expanded ? '90' : '0'}deg)`,
                            transition: 'transform 0.2s '
                        }} type='right'
                        />
                    </div>

                </Row>
            }
            <div className={this.state.expanded ? 'fit-height' : ''} style={{
                height: this.state.expanded ? null : 0,
                // height: this.state.expanded ? '-moz-fit-content' : 0,
                // paddingLeft: 8,
                // height:
                transition: 'height 2s',
                overflowY: 'hidden'
            }}>
                {childItem.map((item, index) => {
                    return getMenuItem({
                        menuKey: menuKey,
                        branchLevel: branchLevel + 1,
                        type: item.type,
                        expandTree: 'secondary',
                        param: this.props.param,
                        isActive: true,
                        ...item
                    })
                })}


            </div>
        </div>

    }

}
